import React from 'react';
import VipSetting from '../components/VipSetting';

// Tools & Lists > Set VIP Period (Azure exit WS8). VIP_CURRENT_PERIOD; ws8_set_vip_period.
export default function SetVipPeriod() {
  return (
    <VipSetting
      title="Set VIP Period"
      feature="ws8_set_vip_period"
      action="set_vip_period"
      fieldName="VIP_CURRENT_PERIOD"
      intro="You can set the period for the VIP system here."
      ask="Which Period?"
      options={[['PERIOD_ONE', '1'], ['PERIOD_TWO', '2'], ['PERIOD_THREE', '3']]}
      saveLabel="Update Period"
    />
  );
}
